// extracted by mini-css-extract-plugin
export default {"div":"Result_div__CuTT-","error":"Result_error__6UqQZ"};